// 公共样式
export const commonStyle = {
  rotate: 0,
  opacity: 1
}

export const commonAttr = {
  animations: [],
  events: {},
  groupStyle: {}, // 当一个组件成为 Group 的子组件时使用
  isLock: false, // 是否锁定组件
  collapseName: 'style', // 编辑组件时记录当前使用的是哪个折叠面板，再次回来时恢复上次打开的折叠面板，优化用户体验
  linkage: {
    duration: 0, // 过渡持续时间
    data: [
      // 组件联动
      {
        id: '', // 联动的组件 id
        label: '', // 联动的组件名称
        event: '', // 监听事件
        style: [{ key: '', value: '' }] // 监听的事件触发时，需要改变的属性
      }
    ]
  }
}

// 编辑器左侧组件列表
const list = [
  //   {
  //     component: 'VText',
  //     label: '文字',
  //     propValue: '双击编辑文字',
  //     icon: 'wenben',
  //     request: {
  //       method: 'GET',
  //       data: [],
  //       url: '',
  //       series: false, // 是否定时发送请求
  //       time: 1000, // 定时更新时间
  //       paramType: '', // string object array
  //       requestCount: 0 // 请求次数限制，0 为无限
  //     },
  //     style: {
  //       width: 200,
  //       height: 28,
  //       fontSize: 14,
  //       fontWeight: 400,
  //       lineHeight: '',
  //       letterSpacing: 0,
  //       textAlign: '',
  //       color: ''
  //     }
  //   },
  //   {
  //     component: 'VButton',
  //     label: '按钮',
  //     propValue: '按钮',
  //     icon: 'button',
  //     style: {
  //       width: 100,
  //       height: 34,
  //       borderWidth: 1,
  //       borderColor: '',
  //       borderRadius: '',
  //       fontSize: 14,
  //       fontWeight: 400,
  //       lineHeight: '',
  //       letterSpacing: 0,
  //       textAlign: '',
  //       color: '',
  //       backgroundColor: ''
  //     }
  //   },
  //   {
  //     component: 'Picture',
  //     label: '图片',
  //     icon: 'tupian',
  //     propValue: {
  //     //   url: require(''),
  //       flip: {
  //         horizontal: false,
  //         vertical: false
  //       }
  //     },
  //     style: {
  //       width: 300,
  //       height: 200,
  //       borderRadius: ''
  //     }
  //   },
  //   {
  //     component: 'RectShape',
  //     label: '矩形',
  //     propValue: '&nbsp;',
  //     icon: 'juxing',
  //     style: {
  //       width: 200,
  //       height: 200,
  //       fontSize: 14,
  //       fontWeight: 400,
  //       lineHeight: '',
  //       letterSpacing: 0,
  //       textAlign: 'center',
  //       color: '',
  //       borderColor: '#000',
  //       borderWidth: 1,
  //       backgroundColor: '',
  //       borderStyle: 'solid',
  //       borderRadius: '',
  //       verticalAlign: 'middle'
  //     }
  //   },
  //   {
  //     component: 'LineShape',
  //     label: '直线',
  //     propValue: '',
  //     icon: 'zhixian',
  //     style: {
  //       width: 200,
  //       height: 2,
  //       backgroundColor: '#000'
  //     }
  //   },
  //   {
  //     component: 'CircleShape',
  //     label: '圆形',
  //     propValue: '&nbsp;',
  //     icon: '24gl-circle',
  //     style: {
  //       width: 200,
  //       height: 200,
  //       fontSize: 14,
  //       fontWeight: 400,
  //       lineHeight: '',
  //       letterSpacing: 0,
  //       textAlign: 'center',
  //       color: '',
  //       borderColor: '#000',
  //       borderWidth: 1,
  //       backgroundColor: '',
  //       borderStyle: 'solid',
  //       borderRadius: '',
  //       verticalAlign: 'middle'
  //     }
  //   },
  //   {
  //     component: 'SVGStar',
  //     label: '星形',
  //     icon: 'kongwujiaoxing',
  //     propValue: '',
  //     style: {
  //       width: 80,
  //       height: 80,
  //       fontSize: 14,
  //       fontWeight: 400,
  //       lineHeight: '',
  //       letterSpacing: 0,
  //       textAlign: 'center',
  //       color: '',
  //       borderColor: '#000',
  //       backgroundColor: 'rgba(255, 255, 255, 1)'
  //     }
  //   },
  //   {
  //     component: 'SVGTriangle',
  //     label: '三角形',
  //     icon: 'xingzhuang-sanjiaoxing',
  //     propValue: '',
  //     style: {
  //       width: 80,
  //       height: 80,
  //       fontSize: 14,
  //       fontWeight: 400,
  //       lineHeight: '',
  //       letterSpacing: 0,
  //       textAlign: 'center',
  //       color: '',
  //       borderColor: '#000',
  //       backgroundColor: 'rgba(255, 255, 255, 1)'
  //     }
  //   },
  //   {
  //     component: 'VTable',
  //     label: '表格',
  //     icon: 'biaoge',
  //     propValue: {
  //       data: [
  //         ['表头1', '表头2', '表头3'],
  //         ['内容1', '内容2', '内容3']
  //       ],
  //       stripe: true,
  //       thBold: true
  //     },
  //     request: {
  //       method: 'GET',
  //       data: [],
  //       url: '',
  //       series: false,
  //       time: 1000,
  //       paramType: '', // string object array
  //       requestCount: 0 // 请求次数限制，0 为无限
  //     },
  //     style: {
  //       width: 600,
  //       height: 200,
  //       fontSize: 14,
  //       fontWeight: 400,
  //       textAlign: 'center',
  //       color: '',
  //       backgroundColor: 'rgba(255, 255, 255, 1)'
  //     }
  //   },
  //   {
  //     component: 'VChart',
  //     label: '图表',
  //     icon: 'el-icon-data-analysis',
  //     propValue: {
  //       chart: 'VChart',
  //       option: {
  //         title: {
  //           text: '柱状图',
  //           show: true
  //         },
  //         legend: {
  //           show: true
  //         },
  //         tooltip: {
  //           show: true,
  //           trigger: 'item'
  //         },
  //         xAxis: {
  //           show: true,
  //           data: ['A', 'B', 'C', 'D', 'E']
  //         },
  //         yAxis: {},
  //         series: {
  //           type: 'bar',
  //           name: '销量',
  //           data: [23, 61, 35, 77, 35],
  //           itemStyle: {
  //             barBorderRadius: 5,
  //             borderWidth: 1,
  //             borderType: 'solid',
  //             borderColor: '#73c0de',
  //             shadowColor: '#5470c6',
  //             shadowBlur: 3
  //           }
  //         }
  //       }
  //     },
  //     style: {
  //       width: 800,
  //       height: 500,
  //       borderRadius: ''
  //     }
  //   }
  {
    component: 'ProjectName',
    propValue: '双击编辑文字',
    realComponent: 'ProjectName',
    label: '项目名称',
    url: require('@/assets/images/custom-screen/u70052.png'),
    style: {
      width: 462,
      height: 50,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 50,
      letterSpacing: 0,
      textAlign: 'center',
      color: 'rgb(255,255,255)',
      borderRadius: 4,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'VText',
    propValue: '双击编辑文字',
    realComponent: 'NoticeCom',
    label: '公告',
    url: require('@/assets/images/custom-screen/u70052.png'),
    style: {
      width: 600,
      height: 40,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 40,
      letterSpacing: 0,
      textAlign: 'center',
      color: 'rgb(255,255,255)',
      borderRadius: 4,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'TimeCom',
    realComponent: 'TimeCom',
    label: '日期时间',
    url: require('@/assets/images/custom-screen/u70055.png'),
    propValue: {
      url: require('@/assets/images/custom-screen/u70055.png'),
      flip: {
        horizontal: false,
        vertical: false
      }
    },
    style: {
      width: 380,
      height: 120,
      fontSize: 32,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '#ffffff',
      borderRadius: 4,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'Picture',
    realComponent: 'Picture',
    label: '添加图片',
    url: require('@/assets/images/custom-screen/picture.png'),
    propValue: {},
    style: {
      width: 250,
      height: 142
    }
  },
  {
    component: 'Video',
    realComponent: 'Video',
    label: '添加视频',
    url: require('@/assets/images/custom-screen/video.png'),
    propValue: {},
    style: {
      width: 250,
      height: 142,
      loop: true
    }
  },
  {
    component: 'VMap',
    realComponent: 'VMapCom',
    label: '项目地图',
    propValue: '项目地图',
    url: require('@/assets/images/custom-screen/u70082.png'),
    style: {
      width: 1000,
      height: 1080,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      top: 0,
      left: 0
    }
  },
  {
    component: 'ProjectInfoCom',
    label: '项目信息',
    realComponent: 'ProjectInfoCom',
    propValue: {
      url: require('@/assets/images/custom-screen/u70040.png'),
      flip: {
        horizontal: false,
        vertical: false
      }
    },
    url: require('@/assets/images/custom-screen/u70040.png'),
    style: {
      width: 380,
      height: 180,
      fontSize: 14,
      titleFontSize: 20,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: 'rgb(255,255,255)',
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'ContractorCom',
    label: '参建单位',
    realComponent: 'ContractorCom',
    propValue: {
      url: require('@/assets/images/custom-screen/u70043.png'),
      flip: {
        horizontal: false,
        vertical: false
      }
    },
    style: {
      width: 380,
      height: 180,
      fontSize: 14,
      titleFontSize: 20,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: 'rgb(255,255,255)',
      background: 'rgba(4, 32, 104,.7)'
    },
    url: require('@/assets/images/custom-screen/u70043.png')
  },
  {
    component: 'AttendanceFactCom',
    label: '出勤实况',
    realComponent: 'AttendanceFactCom',
    url: require('@/assets/images/custom-screen/u70046.png'),
    propValue: {
      url: require('@/assets/images/custom-screen/u70046.png'),
      flip: {
        horizontal: false,
        vertical: false
      }
    },
    style: {
      width: 416,
      height: 150,
      fontSize: 30,
      titleFontSize: 20,
      subTitleFontSize: 18,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: 'rgb(255,255,255)',
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'InOutFactCom',
    label: '进出场实况',
    realComponent: 'InOutFactCom',
    url: require('@/assets/images/custom-screen/u70049.png'),
    propValue: {
      url: require('@/assets/images/custom-screen/u70049.png'),
      flip: {
        horizontal: false,
        vertical: false
      }
    },
    style: {
      width: 414,
      height: 590,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '#ffffff',
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'ProjectPersonCom',
    realComponent: 'ProjectPersonCom',
    label: '项目人数',
    url: require('@/assets/images/custom-screen/u70058.png'),
    propValue: {
      url: require('@/assets/images/custom-screen/u70058.png'),
      flip: {
        horizontal: false,
        vertical: false
      }
    },
    style: {
      width: 380,
      height: 240,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 4,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'InsideCom',
    realComponent: 'InsideCom',
    label: '场内人数',
    url: require('@/assets/images/custom-screen/u70061.png'),
    propValue: {
      url: require('@/assets/images/custom-screen/u70061.png'),
      flip: {
        horizontal: false,
        vertical: false
      }
    },
    style: {
      width: 300,
      height: 240,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 4,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'VChart',
    realComponent: 'VChartCom',
    componentType: 'AttendanceRate',
    label: '考勤率',
    url: require('@/assets/images/custom-screen/u70064.png'),
    propValue: {
      chart: 'VChart',
      title: '考勤率',
      rateNum: '80%',
      option: {
        color: ['#0e8b98', '#157de1'],
        tooltip: {
          show: true,
          trigger: 'item'
        },
        series: [
          {
            name: '考勤率',
            type: 'pie',
            radius: ['50%', '80%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 0, name: '缺勤' },
              { value: 0, name: '出勤' }
            ]
          }
        ]
      }
    },
    style: {
      width: 190,
      height: 190,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)',
      titleFontSize: 16,
      rateFontSize: 26
    }
  },
  {
    component: 'VChart',
    realComponent: 'VChartCom',
    componentType: 'InsidePersonCount',
    label: '场内人数',
    url: require('@/assets/images/custom-screen/u70067.png'),
    propValue: {
      chart: 'VChart',
      option: {
        title: {
          text: '场内人数',
          textStyle: {
            color: '#ffffff'
          },
          show: true
        },
        legend: {
          show: true,
          textStyle: {
            color: '#ffffff'
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        grid: {
          bottom: '14%',
          top: '20%'
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: '劳务工人',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '管理人员',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '其他人员',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 450,
      height: 248,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)',
      fontSize: 18
    }
  },
  {
    component: 'VChart',
    label: '进出人数',
    realComponent: 'VChartCom',
    componentType: 'InOutPersonCount',
    url: require('@/assets/images/custom-screen/u70070.png'),
    propValue: {
      chart: 'VChart',
      option: {
        title: {
          text: '进出人数',
          textStyle: {
            color: '#ffffff'
          },
          show: true
        },
        legend: {
          show: true,
          textStyle: {
            color: '#ffffff'
          }
        },
        grid: {
          bottom: '14%',
          top: '20%'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: '进场人数',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '出场人数',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 450,
      height: 248,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)',
      fontSize: 18
    }
  },
  {
    component: 'VChart',
    realComponent: 'VChartCom',
    componentType: 'AttendanceTeam',
    label: '出勤班组',
    url: require('@/assets/images/custom-screen/u70073.png'),
    propValue: {
      chart: 'VChart',
      option: {
        title: {
          text: '出勤班组',
          show: true,
          textStyle: {
            color: '#ffffff'
          }
        },
        legend: {
          show: true,
          textStyle: {
            color: '#ffffff'
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '14%',
          top: '20%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: '班组人数',
            type: 'bar',
            data: []
          },
          {
            name: '考勤人数',
            type: 'bar',
            data: []
          }
        ]
      }
    },
    style: {
      width: 450,
      height: 248,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)',
      fontSize: 18
    }
  },
  {
    component: 'VChart',
    realComponent: 'VChartCom',
    componentType: 'AttendanceWokerType',
    label: '出勤工种',
    url: require('@/assets/images/custom-screen/u70076.png'),
    propValue: {
      chart: 'VChart',
      option: {
        title: {
          text: '出勤工种',
          show: true,
          textStyle: {
            color: '#ffffff'
          }
        },
        legend: {
          show: true,
          textStyle: {
            color: '#ffffff'
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '14%',
          top: '20%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: '总人数',
            type: 'bar',
            data: []
          },
          {
            name: '考勤人数',
            type: 'bar',
            data: []
          }
        ]
      }
    },
    style: {
      width: 450,
      height: 248,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'AreaAttendance',
    realComponent: 'AreaAttendance',
    label: '区域出勤实况',
    url: require('@/assets/images/custom-screen/u72270.png'),
    propValue: '',
    style: {
      width: 468,
      height: 370,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 4,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'VideoMonitor',
    realComponent: 'VideoMonitor',
    label: '视频监控（1屏）',
    url: require('@/assets/images/custom-screen/1692694496209.jpg'),
    propValue: '',
    videoNum: 1,
    style: {
      width: 468,
      height: 370,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 4,
      background: '#191d38',
      deviceType: 'IPC',
      deviceId: '',
      duration: 0
    }
  },
  {
    component: 'VideoMonitor',
    realComponent: 'VideoMonitor',
    label: '视频监控（4屏）',
    url: require('@/assets/images/custom-screen/1692694536277.jpg'),
    propValue: '',
    videoNum: 4,
    style: {
      width: 468,
      height: 370,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 4,
      background: '#191d38',
      deviceType: 'IPC',
      deviceId: '',
      duration: 0
    }
  },
  {
    component: 'VideoMonitor',
    realComponent: 'VideoMonitor',
    label: '视频监控（9屏）',
    url: require('@/assets/images/custom-screen/1692694546691.jpg'),
    propValue: '',
    videoNum: 9,
    style: {
      width: 468,
      height: 370,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 4,
      background: '#191d38',
      deviceType: 'IPC',
      deviceId: '',
      duration: 0
    }
  },
  {
    component: 'EnvironmentalMonitor',
    realComponent: 'EnvironmentalMonitor',
    label: '环境监测（实时数据）',
    url: require('@/assets/images/custom-screen/1692694560975.jpg'),
    propValue: '',
    style: {
      width: 300,
      height: 400,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 4,
      background: 'rgba(4, 32, 104,.7)',
      interval: 600000
    }
  },
  {
    component: 'VChartCom',
    label: '环境监测（今日趋势）',
    realComponent: 'VChartCom',
    componentType: 'EnvironmentalMonitor',
    url: require('@/assets/images/custom-screen/1692694590405.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        color: [
          '#0a4196',
          '#175785',
          '#115064',
          '#4e534f',
          '#484365',
          '#0d256c',
          '#263486',
          '#2b2a8c',
          '#1f418e',
          '#095083'
        ],
        title: {
          text: '环境监测（今日趋势）',
          textStyle: {
            color: '#00cbfe'
          },
          show: true
        },
        legend: {
          show: true,
          textStyle: {
            color: '#ffffff'
          },
          bottom: '2%'
        },
        grid: {
          bottom: '14%',
          top: '20%'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [
              '00',
              '01',
              '02',
              '03',
              '04',
              '05',
              '06',
              '07',
              '08',
              '09',
              '10'
            ],
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: 'TSP',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: 'PM10',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: 'PM2.5',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '噪音',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '湿度',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '温度',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '风向',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '风速',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '风力',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '气压',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 700,
      height: 348,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'TowerCrane',
    realComponent: 'TowerCrane',
    label: '塔机（实时数据）',
    url: require('@/assets/images/custom-screen/1692694601336.jpg'),
    propValue: '',
    style: {
      width: 892,
      height: 450,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 4,
      background: 'rgba(4, 32, 104,.7)',
      interval: 600000
    }
  },
  {
    component: 'DeviceVChartCom',
    realComponent: 'DeviceVChartCom',
    componentType: 'TowerWarning',
    label: '塔机（今日报警）',
    title: '今日报警',
    url: require('@/assets/images/custom-screen/1692694612409.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        color: ['#0e8b98', '#157de1'],
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b}: {d}%'
        },
        legend: {
          bottom: '2%',
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        grid: {
          top: '5%'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 300,
      height: 246,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'DeviceVChartCom',
    realComponent: 'DeviceVChartCom',
    componentType: 'TowerError',
    label: '塔机（今日故障）',
    title: '今日故障',
    url: require('@/assets/images/custom-screen/1692694621238.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        color: ['#0e8b98', '#157de1'],
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b}: {d}%'
        },
        legend: {
          bottom: '2%',
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        grid: {
          top: '5%'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 300,
      height: 246,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'Lift',
    realComponent: 'Lift',
    label: '升降机（实时数据）',
    url: require('@/assets/images/custom-screen/1692694648659.jpg'),
    propValue: '',
    style: {
      width: 892,
      height: 450,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 4,
      background: 'rgba(4, 32, 104,.7)',
      interval: 600000
    }
  },
  {
    component: 'DeviceVChartCom',
    realComponent: 'DeviceVChartCom',
    componentType: 'LiftWarning',
    label: '升降机（今日报警）',
    title: '今日报警',
    url: require('@/assets/images/custom-screen/1692694640464.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        color: ['#0e8b98', '#157de1'],
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b}: {d}%'
        },
        legend: {
          bottom: '2%',
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        grid: {
          top: '5%'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 300,
      height: 246,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'DeviceVChartCom',
    realComponent: 'DeviceVChartCom',
    componentType: 'LiftError',
    label: '升降机（今日故障）',
    title: '今日故障',
    url: require('@/assets/images/custom-screen/1692694630316.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        color: ['#0e8b98', '#157de1'],
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b}: {d}%'
        },
        legend: {
          bottom: '2%',
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        grid: {
          top: '5%'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 300,
      height: 246,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'DeviceVChartCom',
    realComponent: 'DeviceVChartCom',
    componentType: 'Overview',
    label: '车辆识别（现场概况）',
    title: '现场概况',
    url: require('@/assets/images/custom-screen/1692694658693.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        legend: {
          show: true,
          textStyle: {
            color: '#ffffff'
          },
          bottom: '4%'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '20%',
          top: '20%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: '车队车辆总数',
            type: 'bar',
            data: []
          },
          {
            name: '在场车辆总数',
            type: 'bar',
            data: []
          }
        ]
      }
    },
    style: {
      width: 300,
      height: 246,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'DeviceVChartCom',
    realComponent: 'DeviceVChartCom',
    componentType: 'InOut',
    label: '车辆识别（进出车次）',
    url: require('@/assets/images/custom-screen/1692694670693.jpg'),
    title: '进出车次',
    propValue: {
      chart: 'VChart',
      option: {
        legend: {
          show: true,
          textStyle: {
            color: '#ffffff'
          },
          bottom: '4%'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        grid: {
          bottom: '20%',
          top: '20%'
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: '进场车次',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '出场车次',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 300,
      height: 246,
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'VehicleRecord',
    realComponent: 'VehicleRecord',
    label: '车辆识别记录',
    url: require('@/assets/images/custom-screen/1692694720272.jpg'),
    propValue: {
      url: require('@/assets/images/custom-screen/1692694720272.jpg'),
      flip: {
        horizontal: false,
        vertical: false
      }
    },
    style: {
      width: 462,
      height: 842,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '',
      borderRadius: 8,
      background: 'rgba(4, 32, 104,.7)'
    }
  },
  {
    component: 'ElectricityVChartCom',
    realComponent: 'ElectricityVChartCom',
    componentType: 'ElectricalCondition',
    label: '用电情况',
    url: require('@/assets/images/custom-screen/1692694679029.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        legend: {
          show: false,
          textStyle: {
            color: '#ffffff'
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: '{b}<br/>{a}: {c} KW.h'
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        grid: {
          bottom: '20%',
          top: '20%'
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: '电量',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 450,
      height: 248,
      borderRadius: 8,
      background: '#042068'
    }
  },
  {
    component: 'ElectricityVChartCom',
    realComponent: 'ElectricityVChartCom',
    componentType: 'LeakageMonitor',
    label: '漏电流监测',
    url: require('@/assets/images/custom-screen/1692694691877.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        legend: {
          show: false,
          textStyle: {
            color: '#ffffff'
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: '{b}<br/>{a}: {c} mA'
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        grid: {
          bottom: '14%',
          top: '20%'
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: '电流',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      }
    },
    style: {
      width: 450,
      height: 248,
      borderRadius: 8,
      background: '#042068'
    }
  },
  {
    component: 'ElectricityVChartCom',
    realComponent: 'ElectricityVChartCom',
    componentType: 'ElectricalWarn',
    label: '用电报警',
    url: require('@/assets/images/custom-screen/1692694702918.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        color: ['#157fe8', '#11aab4', '#29aa5c', '#d6b220', '#cd4264'],
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b}: {d}%'
        },
        legend: {
          bottom: '1%',
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        grid: {
          bottom: '20%'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 0, name: '温度' },
              { value: 0, name: '电流过载' },
              { value: 0, name: '电压中断' },
              { value: 0, name: '电压低压' },
              { value: 0, name: '电压高压' }
            ]
          }
        ]
      }
    },
    style: {
      width: 450,
      height: 248,
      borderRadius: 8,
      background: '#042068'
    }
  },
  {
    component: 'ElectricityVChartCom',
    realComponent: 'ElectricityVChartCom',
    componentType: 'ElectricalStatistics',
    label: '各区域用电量统计',
    url: require('@/assets/images/custom-screen/1692694710829.jpg'),
    propValue: {
      chart: 'VChart',
      option: {
        legend: {
          show: false,
          bottom: '2%',
          textStyle: {
            color: '#ffffff'
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: '{b}<br/>{a}: {c} KW.h'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          top: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#404040',
                type: 'dashed'
              }
            },
            axisLabel: { color: '#a6a6a6' }
          }
        ],
        series: [
          {
            name: '电量',
            type: 'bar',
            data: []
          }
        ]
      }
    },
    style: {
      width: 450,
      height: 248,
      borderRadius: 8,
      background: '#042068'
    }
  },
  {
    component: 'AIBehaviorAlertCom',
    realComponent: 'AIBehaviorAlertCom',
    label: 'AI行为告警',
    url: require('@/assets/images/custom-screen/u101526.png'),
    propValue: {
      url: require('@/assets/images/custom-screen/u101526.png'),
      flip: {
        horizontal: false,
        vertical: false
      }
    },
    style: {
      width: 414,
      height: 590,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: '',
      color: '#ffffff',
      background: 'rgba(4, 32, 104,.7)',
      direction: 'vertical'
    }
  }
]

for (let i = 0, len = list.length; i < len; i++) {
  const item = list[i]
  item.style = { ...commonStyle, ...item.style }
  list[i] = { ...commonAttr, ...item }
}

export default list
